// routes
import {
  PATH_ADS,
  PATH_BRANDS,
  PATH_CREATIVE_CENTER,
  PATH_PRODUCTS,
  PATH_BEST_SELLING_PRODUCTS,
  PATH_TOP30_PRODUCTS,
  PATH_COMPETITOR_ANALYSIS,
} from "../../../routes/paths";
import { getIcon } from "./NavIcon";
import { UserRole, User } from "../../../types/auth";

export const ICONS = {
  home: getIcon("home"),
  ads: getIcon("ads"),
  trending: getIcon("trending"),
  brands: getIcon("brands"),
  competitor_analytics: getIcon("competitor_analytics"),
  products: getIcon("products"),
  bestSellingProducts: getIcon("best_selling_products"),
  top30Products: getIcon("best_selling_products"), // Using same icon for now
  search: getIcon("search"),
  boards: getIcon("my-boards"),
  add_brand: getIcon("add-brand"),
};

const getNavConfig = (user?: User | null) => {
  const isAdmin = user?.is_superuser || user?.role === UserRole.ADMIN;
  
  const dashboardItems = [];
  
  // Only show Top 30 Products for Admin users
  if (isAdmin) {
    dashboardItems.push({
      title: "Top 30 Products",
      path: PATH_TOP30_PRODUCTS.root,
      icon: ICONS.top30Products,
    });
  }
  
  dashboardItems.push(
    {
      title: "Brands",
      path: PATH_BRANDS.trending,
      icon: ICONS.brands,
      children: [
        {
          title: "Trending Brands",
          path: PATH_BRANDS.trending,
          icon: ICONS.trending,
        },
        {
          title: "Discover Brands",
          path: PATH_BRANDS.discover,
          icon: ICONS.brands,
        },
      ],
    },
    {
      title: "Products",
      path: PATH_PRODUCTS.root,
      icon: ICONS.products,
      children: [
        {
          title: "Featured Products",
          path: PATH_PRODUCTS.root,
          icon: ICONS.products,
        },
        {
          title: "Best Selling Products",
          path: PATH_BEST_SELLING_PRODUCTS.root,
          icon: ICONS.bestSellingProducts,
        },
      ],
    },
    {
      title: "Discover Ads",
      path: PATH_ADS.trending,
      icon: ICONS.ads,
    },
    {
      title: "Competitor Analytics",
      path: PATH_COMPETITOR_ANALYSIS.mapOfBrands,
      icon: ICONS.competitor_analytics,
    },
    {
      title: "Creative Center",
      path: PATH_CREATIVE_CENTER.boards,
      icon: ICONS.boards,
    },
    {
      title: "Add Brand",
      path: PATH_BRANDS.addBrand,
      icon: ICONS.add_brand,
    }
  );

  return [
    {
      subheader: "dashboard",
      items: dashboardItems,
    },
  ];
};

export default getNavConfig;
